import styled from 'styled-components';

export const NameTableCellWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
